import { devicecontext } from "./context"; 

export function DeviceContext({ children }) {

    function isMobileDevice() {
        return window.screen.width < 600
    }

    return (
        <devicecontext.Provider value={{ isMobileDevice }}>
            { children }
        </devicecontext.Provider>
    );
}
